/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_Q5Inputs */

const en_pc_dl_faq_q5 = /** @type {(inputs: Pc_Dl_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which Linux distributions does PdfCraft support?`)
};

const zh_pc_dl_faq_q5 = /** @type {(inputs: Pc_Dl_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 支持哪些 Linux 发行版？`)
};

/**
* | output |
* | --- |
* | "Which Linux distributions does PdfCraft support?" |
*
* @param {Pc_Dl_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_q5 = /** @type {((inputs?: Pc_Dl_Faq_Q5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_Q5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_q5(inputs)
	return zh_pc_dl_faq_q5(inputs)
});
export { pc_dl_faq_q5 as "pc.dl.faq.q5" }